const subMenuArrTherma = [
	{key:'thermatru_difference',id:'thermatru_difference', label:'The Therma-Tru Difference', depthlevel : 1 ,color : '#E91E23',},
	{key:'thermatru_new_products',id:'thermatru_new_products', label:'Trends & New Products', depthlevel : 1,color : '#E91E23',},
	{key:'thermatru_key_success', id:'thermatru_key_success',label:'Keys 2 Success', depthlevel : 1,color : '#E91E23',},
	{key:'thermatru_tools_support', id:'thermatru_tools_support',label:'Certified Installer Training Program', depthlevel : 1,color : '#E91E23',},
	{key:'thermatru_tools_support',id:'thermatru_tools_support2', label:'Tools & Support', depthlevel : 1,color : '#E91E23',},

];


const subMenuArrFypon = [
	{key:'fypon_advantage', id:'fypon_advantage', label:'The Fypon Advantage' , depthlevel : 1, color : '#0079C1'},
	{key:'fypon_new_products', id:'fypon_new_products', label:'New Products', depthlevel : 1, color : '#0079C1'},
	{key:'tools_support_fypon', id:'tools_support_fypon', label:'Explore Fypon', depthlevel : 1, color : '#0079C1'},
	{key:'tools_support_fypon', id:'tools_support_fypon2', label:'Tools & Support', depthlevel : 1, color : '#0079C1'},
]

const subMenuSme = [
	{key:'sme_add_participant', label:'Add Participants' , depthlevel : 1, color : '#E91E23'},
	{key:'sme_start_session', label:'Start Session', depthlevel : 1, color : '#E91E23'},
	{key:'sme_end_session', label:'End Session', depthlevel : 1, color : '#E91E23'},
]

export const menuArr = [
	{key:'therma', label:'Therma-Tru', subArr:subMenuArrTherma , color : '#E91E23', class : 'colaps' ,depthlevel : 0 },
	{key:'success', label:'Key 2 Success', color : '', class : '' ,depthlevel : 0},
	{key:'fypon', label:'Fypon', subArr:subMenuArrFypon, color : '#0079C1', class : 'colaps' ,depthlevel : 0},
	{key:'media', label:'PR & Media',color : '#E91E23', class : '' ,depthlevel : 0},
	{key:'Guide', label:'Guided Path',color : '#E91E23', class : '' ,depthlevel : 0},
	{key:'sme', label:'Sales Guided Tour',subArr:subMenuSme, color : '#E91E23', class : 'colaps' ,depthlevel : 0},

]

export const sliderHotspotArr = [
	{key:'hot0', pos:{x:30, y:45}, title:'Hotspot1', des:'description1' ,ref : 'fypon_explorer_home1_hs1'},
	{key:'hot1', pos:{x:70, y:55}, title:'Hotspot2', des:'description2',ref : 'fypon_explorer_home1_hs2'},
]

export const home1HotspotArr = [
	{key:'hot0', pos:{x:35, y:30}, title:'gablepediment', des:'description1' ,ref : 'gablepediment'},
	{key:'hot1', pos:{x:42, y:32}, title:'dentilblock', des:'description2',ref : 'dentilblock'},
	{key:'hot2', pos:{x:41, y:45}, title:'shakerstyleshutter', des:'description3',ref : 'shakerstyleshutter'},
	{key:'hot3', pos:{x:64, y:28}, title:'louver', des:'description4',ref : 'louver'},
	{key:'hot4', pos:{x:92, y:57}, title:'craftmanstylecrosshead', des:'description5',ref : 'craftmanstylecrosshead'},
	{key:'hot5', pos:{x:80, y:67}, title:'raisedpanelshutter', des:'description6',ref : 'raisedpanelshutter'},
	{key:'hot6', pos:{x:71, y:63}, title:'coloumnwrap', des:'description7',ref : 'coloumnwrap'},
	{key:'hot7', pos:{x:62, y:71}, title:'railsystem_home1', des:'description8',ref : 'railsystem_home1'},
	{key:'hot8', pos:{x:51, y:57}, title:'trellissystem', des:'description9',ref : 'trellissystem'},
]

export const home2HotspotArr = [
	{key:'hot0', pos:{x:27, y:31}, title:'brackets', des:'description1' ,ref : 'brackets'},
	{key:'hot1', pos:{x:39, y:17}, title:'fishscalepanels', des:'description2',ref : 'fishscalepanels'},
	{key:'hot2', pos:{x:45, y:3}, title:'spires', des:'description3',ref : 'spires'},
	{key:'hot3', pos:{x:50, y:50}, title:'dentilblocks', des:'description4',ref : 'dentilblocks'},
	{key:'hot4', pos:{x:61, y:72}, title:'railsystem_home2', des:'description5',ref : 'railsystem_home2'},
	{key:'hot5', pos:{x:36, y:58}, title:'columnwrap', des:'description6',ref : 'columnwrap'},

]

export const livingRoomHotspotArr = [
	{key:'hot0', pos:{x:28, y:5}, title:'smoothbeams', des:'description1' ,ref : 'smoothbeams'},
	{key:'hot1', pos:{x:29, y:58}, title:'smoothmantels', des:'description2',ref : 'smoothmantels'},
	{key:'hot2', pos:{x:81, y:50}, title:'windowtrimsurroundings', des:'description3',ref : 'windowtrimsurroundings'},
	
]

export const foyerHotspotArr = [
	{key:'hot0', pos:{x:19, y:3}, title:'beams', des:'description1' ,ref : 'beams'},
	{key:'hot1', pos:{x:35, y:19}, title:'foyr_craftmanstylecrosshead', des:'description2',ref : 'foyr_craftmanstylecrosshead'},
	{key:'hot2', pos:{x:31, y:40}, title:'pilaster', des:'description3',ref : 'pilaster'},
	{key:'hot3', pos:{x:81, y:52}, title:'smoothflattrim', des:'description3',ref : 'smoothflattrim'},

]

export const otherProductsHotspotArr = [
	{key:'hot0', pos:{x:45.2, y:28}, title:'premiumquickpost', des:'description1' ,ref : 'premiumquickpost'},
	{key:'hot1', pos:{x:90, y:26}, title:'flattrim', des:'description2',ref : 'flattrim'},
	{key:'hot2', pos:{x:73.5, y:66}, title:'railsystem_other', des:'description3',ref : 'railsystem_other'},
	{key:'hot3', pos:{x:26, y:40}, title:'doorsurrounds', des:'description3',ref : 'doorsurrounds'},

]


export const keySuccessRotationHotpspots = [
	{key:'hot0', pos:{x:24.2, y:55}, title:'rules', des:'description1' ,ref : 'keysuccess_rules'},
	{key:'hot1', pos:{x:66, y:40}, title:'prizes', des:'description2',ref : 'keysuccess_prize'},
	{key:'hot2', pos:{x:66, y:40}, title:'progress', des:'description3',ref : 'keysuccess_progress'},

]

const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

//Fypon Slider
export const fyponSliderArr = [

	{
		key : 'home1',
		oldImage : baseUrl+'datas/fypon/fyponexplore/home1/Building Block Before HD.png',
		newImage :  baseUrl+'datas/fypon/fyponexplore/home1/Building Block After HD.png',
		hotspots : home1HotspotArr
	},	
	{
		key : 'home2',
		oldImage :  baseUrl+'datas/fypon/fyponexplore/home2/Victorian Before HD.png',
		newImage :  baseUrl+'datas/fypon/fyponexplore/home2/Victorian After HD.png',
		hotspots : home2HotspotArr
	},
	{
		key : 'livingroom',
		oldImage :  baseUrl+'datas/fypon/fyponexplore/livingroom/Living Room Before HD.png',
		newImage :  baseUrl+'datas/fypon/fyponexplore/livingroom/Living Room After HD.png',
		hotspots : livingRoomHotspotArr
	},	
	{
		key : 'foyer',
		oldImage :  baseUrl+'datas/fypon/fyponexplore/foyer/Foyer Before HD.png',
		newImage :  baseUrl+'datas/fypon/fyponexplore/foyer/Foyer After HD.png',
		hotspots : foyerHotspotArr
	},
	{
		key : 'other_products',
		oldImage :  baseUrl+'datas/fypon/fyponexplore/other/Home Other HD.png',
		newImage : "",
		hotspots : otherProductsHotspotArr
	},
]